/**
 * cart-gift.js (manual add – final)
 *
 * UX:
 * - Locked:
 *   Title: "Unlock Free Gift"
 *   Subtitle: "You're $X away"
 *
 * - Unlocked:
 *   Button: "Add free gift"
 */

(function () {
  'use strict';

  /* ------------------------------------------------------------
    Helpers
  ------------------------------------------------------------ */

  const $ = (sel, ctx = document) => (ctx || document).querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from((ctx || document).querySelectorAll(sel));

  function debounce(fn, wait = 200) {
    let t = null;
    return function (...args) {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  function moneyHTML(cents) {
    const amount = (Number(cents) / 100).toFixed(2);
    return `<span class="theme-money">$${amount}</span>`;
  }

  /* ------------------------------------------------------------
    Config
  ------------------------------------------------------------ */

  function readConfigNode() {
    const cfg = document.getElementById('free-gift-config');
    if (!cfg) return null;

    return {
      thresholdCents: parseInt(cfg.dataset.threshold || 0, 10) || 0,
      variantId: String(cfg.dataset.variantId || '').trim(),
      title: cfg.dataset.title || 'Free gift'
    };
  }

  /* ------------------------------------------------------------
    Cart fetch
  ------------------------------------------------------------ */

  async function fetchCart() {
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!res.ok) throw new Error('Cart fetch failed');
      return await res.json();
    } catch (err) {
      console.warn('cart-gift: fetch error', err);
      return null;
    }
  }

  /* ------------------------------------------------------------
    Subtotal excluding gift
  ------------------------------------------------------------ */

  function computeSubtotalExcludingGift(cart, giftVariantId) {
    let giftPresent = false;
    let giftLineTotal = 0;

    if (!cart || !Array.isArray(cart.items)) {
      return { subtotalExcludingGift: 0, giftPresent: false };
    }

    cart.items.forEach(item => {
      if (String(item.variant_id) === giftVariantId) {
        giftPresent = true;
        giftLineTotal += Number(item.final_line_price || 0);
      }
    });

    const subtotalAll = Number(cart.items_subtotal_price || 0);

    return {
      subtotalExcludingGift: Math.max(0, subtotalAll - giftLineTotal),
      giftPresent
    };
  }

  /* ------------------------------------------------------------
    UI Update
  ------------------------------------------------------------ */

  function updateUI(cart, cfg) {
    const wrapper = $('.cart-gift-progress-wrap');
    if (!wrapper || !cart || !cfg) return;

    const { subtotalExcludingGift, giftPresent } =
      computeSubtotalExcludingGift(cart, cfg.variantId);

    const remaining = Math.max(0, cfg.thresholdCents - subtotalExcludingGift);
    const percent =
      cfg.thresholdCents > 0
        ? Math.min(100, Math.round((subtotalExcludingGift * 100) / cfg.thresholdCents))
        : 0;

    // Progress bar
    const fill = $('.gift-progress-bar__fill', wrapper);
    if (fill) fill.style.width = `${percent}%`;

    // Update remaining amount placeholders
    $$('.gift-remaining-amount', wrapper).forEach(el => {
      el.innerHTML = moneyHTML(remaining);
    });

    const titleEl = $('.cart-gift-perk__title', wrapper);
    const subtitleEl = $('.cart-gift-perk__subtitle', wrapper);

    /* ---------------- LOCKED ---------------- */

    if (remaining > 0) {
      if (titleEl) titleEl.textContent = 'Unlock Free Gift';

      if (subtitleEl) {
        subtitleEl.innerHTML = `You're ${moneyHTML(remaining)} away`;
      }

      wrapper.classList.add('cart-gift-perk--locked');
      wrapper.classList.remove('cart-gift-perk--unlocked');

      const btn = $('.cart-gift-add-btn', wrapper);
      if (btn) btn.remove();

      return;
    }

    /* ---------------- UNLOCKED ---------------- */

    wrapper.classList.remove('cart-gift-perk--locked');
    wrapper.classList.add('cart-gift-perk--unlocked');

    if (titleEl) titleEl.textContent = 'Unlock Free Gift';

    if (giftPresent) {
      if (subtitleEl) {
        subtitleEl.textContent = 'Free gift already added to your cart';
      }
    } else {
      if (subtitleEl) {
        subtitleEl.innerHTML = `
          <button
            type="button"
            class="btn btn--small btn--secondary cart-gift-add-btn"
            data-variant-id="${cfg.variantId}">
            Add free gift
          </button>
        `;
      }
    }
  }

  /* ------------------------------------------------------------
    Refresh orchestration
  ------------------------------------------------------------ */

  const refresh = debounce(async () => {
    const cfg = readConfigNode();
    if (!cfg) return;

    const cart = await fetchCart();
    if (!cart) return;

    updateUI(cart, cfg);
  }, 250);

  window.cartGiftRefresh = refresh;

  /* ------------------------------------------------------------
    Listeners
  ------------------------------------------------------------ */

  function bind() {
    document.addEventListener('DOMContentLoaded', refresh);
    window.addEventListener('cart:updated', refresh);
    window.addEventListener('cart:refresh', refresh);
    window.addEventListener('ajaxCart.afterUpdate', refresh);

    document.addEventListener(
      'click',
      e => {
        if (e.target.closest('.quick-add-btn, .product-form__add-to-cart')) {
          setTimeout(refresh, 700);
        }
      },
      true
    );

    document.addEventListener(
      'change',
      e => {
        if (e.target.matches('input[name="quantity"]')) {
          setTimeout(refresh, 500);
        }
      },
      true
    );
  }

  /* ------------------------------------------------------------
    Add free gift
  ------------------------------------------------------------ */

  document.addEventListener('click', e => {
    const btn = e.target.closest('.cart-gift-add-btn');
    if (!btn) return;

    btn.disabled = true;
    btn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: btn.dataset.variantId,
        quantity: 1
      })
    })
      .then(() => {
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
      })
      .catch(() => {
        btn.disabled = false;
        btn.textContent = 'Add free gift';
      });
  });

  /* ------------------------------------------------------------
    Init
  ------------------------------------------------------------ */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      refresh();
      bind();
    });
  } else {
    refresh();
    bind();
  }
})();
